import { render, staticRenderFns } from "./ASSOCIATEDRISK.vue?vue&type=template&id=b95436c2&"
import script from "./ASSOCIATEDRISK.vue?vue&type=script&lang=js&"
export * from "./ASSOCIATEDRISK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports